<template>
  <div>
    <div class="boires-page-loader-div" v-if="isLoading">
      <div class="boires-page-loader"></div>
    </div>
    <MainLayout v-else>
      <div
        :class="[
          isMobileLayout
            ? 'container single-product'
            : 'product-container single-produt',
        ]"
      >
        <PreviousPageBtn
          v-if="changeProduct"
          :linkTo="setBackBtnLink()"
          :label-code="setBackBtnName()"
        />
        <el-row>
          <el-col :span="isMobileLayout ? 24 : 12">
            <div
              class="rectangle"
              @click="productImagePopup = true"
            >
              <div
                style="position: absolute; right: 21px; top: 20px"
                class="disponible-label"
              >
                <div class="flex">
                  <div
                    :class="[
                      available
                        ? 'couleur-disponible'
                        : 'couleur-non-disponible',
                    ]"
                  />
                  <div class="label ml-5 product-availability-label">
                    {{
                      available
                        ? availableLabel
                        : disponibilite != ""
                        ? disponibilite
                        : notAvailableLabel
                    }} 
                  </div>
                </div>
              </div>
              <el-image
                class="product-image"
                :src="
                  yearProductImage == null ? productImage : yearProductImage
                "
                :fit="'contain'"
                @click="productImagePopup = true"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline" />
                </div>
              </el-image>
              <div v-if="countryCode == 'QC'" class="inventory-circle mb-6">
                <span v-if="inventoryLabel && getRoute != 'STORE_MTL'"
                  class="inventory__label inventory"
                >
                  {{ inventoryLabel }}
                </span>
                <div
                  class="circle circle--position-display"
                  :style="{ background: pastilleColor }"
                />
              </div>
            </div>

            <el-row v-if="!isMobileLayout" class="text-left rectangle mt-15">
              <ProviderDescription
                :provider="productInv"
                class="hidden-xs-only"
              />
            </el-row>
          </el-col>

          <el-col
            :class="[isMobileLayout ? 'mt-20' : 'pl-40', 'text-left']"
            :span="isMobileLayout ? 24 : 12"
          >
            <el-tabs
              v-model="activeYear"
              @tab-click="getYearCommonProperties"
              class="properties-year-list"
            >
              <el-tab-pane
                v-for="(year, index) in releaseYear"
                :key="index"
                :label="year.year"
                :name="year.year"
              ></el-tab-pane>
            </el-tabs>
            <div>
              <h1 class="text-uppercase product-name">
                {{ productTitle }}
              </h1>
              <router-link  :to="providerView" class="product-provider">
                <div class="flex">
                  <span class="subtitle2 light-grey provider">{{
                    provider
                  }}</span>
  
                  <el-image
                    v-if="isBiologique != ''"
                    class="biologique-logo ml-10 mt-3"
                    :src="isBiologique"
                    :fit="'contain'"
                  />
                </div>
              </router-link>
              <span class="provider light-grey"> {{ origin }}</span>
            </div>
            <AddToCartComponent
              class="mt-60"
              v-if="changeProduct"
              :product="product"
              :tax-code="actionBar && actionBar.tax"
              :product-type="previoueBtnName"
              :type="typeOfProduct"
              :get-botique-product="getBotiqueProduct"
              :get-agency-product="getAgencyProduct"
              :inventory-type="inventoryType"
            />
            <el-divider />
            <el-row
              class="p-10 delivery "
              v-if="deliveryAddress != ''"
              style="background-color: #eaedeb"
            >
              <el-col class="delivery-mobile" :span="24">
                <div class="grid-content bg-purple mb-5">
                  <span class="text-uppercase">{{
                    $t("products.deliveryOption")
                  }}</span>
                </div>
              </el-col>
              <el-col class="delivery-mobile" :span="3" style="">
                <div class="grid-content bg-purple pt-10">
                  <img
                    :src="images.pickupIcon.src"
                    alt=""
                    class="delivery-icon"
                  />
                </div>
              </el-col>
              <el-col class="delivery-mobile" :span="9">
                <div class="grid-content bg-purple">
                  <p v-html="deliveryAddress"></p>
                </div>
              </el-col>
              <el-col class="delivery-mobile" :span="3" style="opacity: 0.5">
                <div class="grid-content bg-purple pt-25">
                  <img
                    :src="images.deliveryIcon.src"
                    alt=""
                    class="delivery-icon"
                  />
                </div>
              </el-col>
              <el-col class="delivery-mobile" :span="9">
                <div class="grid-content bg-purple">
                  <p v-html="pickupAddress" style="color: gray"></p>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple mb-5"></div>
              </el-col>
            </el-row>
            <el-row
              class="p-10 delivery"
              v-if="deliveryAddressToronto != ''"
              style="background-color: #eaedeb"
            >
              <el-col :span="24">
                <div class="grid-content bg-purple mb-5">
                  <span class="text-uppercase">{{
                    $t("products.deliveryOption")
                  }}</span>
                </div>
              </el-col>
              <el-col :span="3" style="">
                <div class="grid-content bg-purple pt-10">
                  <img
                    :src="images.pickupIcon.src"
                    alt=""
                    class="delivery-icon"
                  />
                </div>
              </el-col>
              <el-col :span="9">
                <div class="grid-content bg-purple">
                  <p v-html="deliveryAddressToronto"></p>
                </div>
              </el-col>
              <el-col :span="3" style="opacity: 0.5">
                <div class="grid-content bg-purple pt-25">
                  <img
                    :src="images.deliveryIcon.src"
                    alt=""
                    class="delivery-icon"
                  />
                </div>
              </el-col>
              <el-col :span="9">
                <div class="grid-content bg-purple">
                  <p v-html="pickupAddress" style="color: gray"></p>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple mb-5"></div>
              </el-col>
            </el-row>
            <!-- eslint-disable -->
            <div class="mt-40 mb-20" v-html="productDescription" />
            <div class="mt-20" v-if="yearCommonProperties !== null">
              <div v-for="prop in yearCommonProperties" :key="prop.id">
                <el-row v-if="prop.value != null && prop.value !== ''">
                  <el-col :span="8">
                    <span class="prop-label">{{ prop.label }}</span>
                  </el-col>
                  <el-col :span="16">
                    <span class="prop-value">{{ prop.value }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="mt-20" v-else>
              <div v-for="prop in commonProperties" :key="prop.id">
                <el-row v-if="prop.value != null && prop.value !== ''">
                  <el-col :span="8">
                    <span class="prop-label">{{ prop.label }}</span>
                  </el-col>
                  <el-col :span="16">
                    <span class="prop-value">{{ prop.value }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div>
              <el-tabs v-model="activeYear"> </el-tabs>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-row v-if="isMobileLayout" class="text-left rectangle mt-15">
            <!-- Provider Description not available -->
            <ProviderDescription
              :provider="productInv"
              />
              <!-- class="hidden-xs-only" -->
          </el-row>

          <div class="mt-100 home-carousel-product">
            <h3 class="text-left text-uppercase mb-10 ml-5 suggested-product">
              {{ similarProductsLabel }}
            </h3>

            <ProductCarousel
              id="product-carousel"
              :productType="boutiqueType"
              :products="cloneProducts"
              arrow="always"
            />
          </div>
        </el-row>
        <div v-if="blogs && blogs.total > 0" :class="[isMobileLayout ? 'mt-50' : 'mt-140', 'text-left']">
          <el-row>
            <el-col :span="isMobileLayout ? 12 : 3">
              <h2 class="title text-uppercase mb-15 ml-5">
                {{ titleBlogs }}
              </h2>
            </el-col>
            <el-col
              :span="isMobileLayout ? 12 : 21"
              :class="[isMobileLayout ? 'text-right mt-4' : 'pl-10']"
            >
              <!-- <router-link
                :to="blogsView"
                :class="[
                  'el-link el-link--primary is-underline',
                  isMobileLayout ? 'all-products__mobile' : 'ml-15 mt-10',
                ]"
              >
                <span class="el-link--inner">
                  {{ allBlogsLink }}
                </span>
              </router-link> -->
            </el-col>
          </el-row>
          <div
            class="blog-carousel home-blog-carousel"
            style="margin-left: -10px"
          >
            <BlogCarousel
              :carousel-type="2"
              :blogs="topVideos"
              arrow="always"
              :class="[isMobileLayout ? 'mt-12' : '']"
            />
          </div>
        </div>
      </div>
    </MainLayout>
    <el-dialog
      class="image-popup-modal img-popup"
      :visible.sync="productImagePopup"
      :before-close="popupImageClose"
      :header="false"
    >
      <el-row>
        <el-col :xs="24" :sm="24" :md="24">
          <el-image
            class=""
            style="width: 100"
            :src="yearProductImage == null ? productImage : yearProductImage"
            :fit="'contain'"
          >
          </el-image>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import productApi from "@/api/product";
import { filter, get, head, isEmpty, orderBy, reverse, take  } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";
import errorUtils from "@/utils/error-utils";
import { getDefaultAvailability } from "@/utils/market-utils";
import { sortByHierarchyWithAlternation, enrichProductsForMarket } from "@/utils/carousel-sort-utils";

import imgProductDefault from "@/assets/images/product/product-default.png";
import deliveryAddressIcon from "@/assets/images/product/delivery-address-icon.png";
import pickupAddressIcon from "@/assets/images/product/pickup-address-icon.png";

import MainLayout from "@/components/layout/main-layout.vue";
import PreviousPageBtn from "@/components/previous-page-btn.vue";
import AddToCartComponent from "./components/add-to-cart.vue";
import ProviderDescription from "./components/product-description.vue";
import ProductCarousel from "@/views/product/components/product-carousel.vue";
import BlogCarousel from "@/views/blog/components/blog-carousel.vue";
import imgProductLeaf from "@/assets/images/product/leaf.png";
import imgProductMoon from "@/assets/images/product/moon.png";
import cssVariables from "@/assets/variables.scss";
import imgProductInventoryIp from "@/assets/images/product/product-inventory-ip.png";
import imgProductInventorySaq from "@/assets/images/product/product-inventory-saq.png";
export default {
  components: {
    MainLayout,
    AddToCartComponent,
    PreviousPageBtn,
    ProviderDescription,
    ProductCarousel,
    BlogCarousel,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    productType: {
      type: String,
      default: null,
    },
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);

    // Named handler + beforeDestroy cleanup. Previously this used an anonymous
    // listener with no $off, so every product page visit leaked a chancountryCode
    // listener on $root. On a region switch ALL of them fired getProduct() at once
    // — the compounding multi-second spinner that got worse the more you browsed.
    this.$root.$on("chancountryCode", this.onCountryChange);
  },
  data() {
    return {
      activeYear: "",
      isLoading: true,
      previoueBtnName:
        this.$route.query.productType == "STORE_MTL" ||
        this.$route.query.productType == "STORE_QC"
          ? "boutique"
          : "agency",
      images: {
        productDefault: {
          src: imgProductDefault,
        },
        deliveryIcon: {
          src: deliveryAddressIcon,
        },
        pickupIcon: {
          src: pickupAddressIcon,
        },
        productInventoryIp: {
          src: imgProductInventoryIp,
        },
        productInventorySaq: {
          src: imgProductInventorySaq,
        },
      },
      imagePopuup: true,
      changeProduct: true,
      productImagePopup: false,
      productMoonImg: imgProductMoon,
      productLeafImg: imgProductLeaf,
      inventoryType: this.getInventoryType(),
      constants: {
        PRODUCT_COLOR: "PRODUCT_COLOR",
        WHITE: "WHITE",
        PALE_ORANGE: "PALE_ORANGE",
        ORANGE: "ORANGE",
        RAMATO: "RAMATO",
        PINK: "PINK",
        PALE_RED: "PALE_RED",
        RED: "RED",
        COLORLESS: "COLORLESS",
        AMBER: "AMBER",
        BLACK: "BLACK",
      },
      yearCommonProperties: null,
      yearProductImage: null,
      countryCode: localStorage.getItem("countryCode") == 'QC' ? 'QC' : 'ON',
      // Vanity URL support: puid resolved from the slug when the URL carries no
      // ?id=. Null for every legacy (?id=) URL, so it never affects them.
      resolvedPuid: null,
      // True only while onCountryChange() is re-resolving this page for the new
      // market. `?id=` pins ONE inventory variant (puids are per variant, not
      // per product), and selectProductInventory() honors that pin ahead of the
      // market — correct on a normal load, wrong on a market switch, where it
      // re-pinned the market we just left. See onCountryChange().
      marketSwitchPending: false,
      // Local result set backing getAgencyProduct() — see getProductLists().
      // Deliberately NOT the shared `product/products` store state.
      agencyCandidates: [],
      // Similar-products carousel: enriched + sorted candidates, loaded
      // explicitly (see loadSimilarProducts) rather than derived in a computed.
      carouselProducts: [],
    };
  },
  computed: {
    ...mapState("product", ["product", "products", "productInv"]),
    // The product identifier the page actually fetches by. `?id=` (every link
    // the app currently emits) always wins; the slug-resolved puid is only used
    // as a fallback when no ?id= is present. So legacy URLs behave identically.
    effectiveProductId() {
      return this.$route.query.id || this.resolvedPuid;
    },
    // The puid to prefer when picking which inventory variant this page shows.
    // Same as effectiveProductId, except during a market switch: there the URL
    // still names the variant of the market we are leaving, so preferring it
    // would keep the old market's price, availability badge and CTA on screen.
    // Falling back to null makes selectProductInventory() choose by market.
    preferredVariantPuid() {
      return this.marketSwitchPending ? null : this.effectiveProductId;
    },
    ...mapState("configuration", ["actionBar"]),
    ...mapState("blog", ["blogs"]), 
    getRoute() {
      return this.$route.query?.productType;
    },
    providerView() {
      return {
        name: "provider",
        params: {
          slug: get(this.product?.cmsProvider, "slug", ""),
        },
      };
    },
    disponibilite() {
      const nextBatches = get(this.product, "erpProduct.itemToCome", "");
      if (isEmpty(nextBatches)) {
        return "";
      }
      if (nextBatches.receptionPlanningDate) {
        var date1 = new Date(nextBatches.receptionPlanningDate);
        var date2 = new Date();
        const month = date1.toLocaleString(this.$i18n.locale, {
          month: "short",
        });
        if (date1.getDate() < date2.getDate()) {
          return `${month.toUpperCase().substring(0, 3)} ${date1
            .getFullYear()
            .toString()
            .slice(-2)}`;
        }
        return `${month.toUpperCase().substring(0, 3)} ${date1
          .getFullYear()
          .toString()
          .slice(-2)}`;
      }
      return "";
    },
    productTitle() {
      return get(this.product, "name");
    },
    productImage() {
      const pImage = get(this.product, "image.link");
      if (pImage == null) {
        return this.images.productDefault.src;
      }
      return pImage;
    },
    availableLabel() {
      return this.$i18n.t("products.productView.label.available");
    },
    notAvailableLabel() {
      return this.$i18n.t("products.productView.label.notAvailable");
    },
    productDescription() {
      return get(this.product, "description");
    },
    origin() {
      const originHead = head(get(this.product, "origins"));
      const country = get(originHead, "country.name");
      const region = get(originHead, "region.name");

      return originHead && `${region == null ? "" : region}, ${country}`;
    },
    currentTechnicalSpecYear() {
      const currentTechnicalSpecId = get(this.product, "currentTechnicalSpec.id");
      if (currentTechnicalSpecId == null) return "";

      const technicalSheet = get(this.product, "technicalSheet");
      if (technicalSheet && get(technicalSheet, "id") === currentTechnicalSpecId) {
        return `${get(technicalSheet, "releaseYear", "")}`;
      }

      const technicalSpecs = get(this.product, "technicalSpecs", []);
      const matchingSpec = technicalSpecs.find((spec) => spec.id === currentTechnicalSpecId);
      if (matchingSpec) {
        return `${matchingSpec.releaseYear || ""}`;
      }

      return "";
    },
    releaseYear() {
      if (this.product == null) return [];

      const technicalSpecs = get(this.product, "technicalSpecs", []);
      const item = head(technicalSpecs);

      if (item && item.releaseYear) {
        const years = technicalSpecs.reduce((accumulator, value) => {
          const releaseYear = get(value, "releaseYear");

          if (releaseYear == null || releaseYear === "") {
            return accumulator;
          }

          const normalizedYear = `${releaseYear}`;
          const existingYear = accumulator.find((entry) => `${entry.year}` === normalizedYear);

          if (existingYear) {
            if (existingYear.onHand == null && value.onHand != null) {
              existingYear.onHand = value.onHand;
            }
            return accumulator;
          }

          accumulator.push({ year: normalizedYear, onHand: value.onHand });
          return accumulator;
        }, []);

        if (
          this.currentTechnicalSpecYear &&
          !years.some((entry) => `${entry.year}` === this.currentTechnicalSpecYear)
        ) {
          years.push({ year: this.currentTechnicalSpecYear, onHand: "" });
        }

        years.sort((a, b) => `${b.year}`.localeCompare(`${a.year}`, undefined, { numeric: true }));
        return years;
      }

      const currentVintage = get(this.product, "currentVintage");
      if (currentVintage) {
        return [{ year: `${currentVintage}`, onHand: "" }];
      }

      return [];
    },
    available() {  
      return get(this.product, "erpProduct.quantity.inStock");
    },
    provider() {
      const aliasName = get(this.product, "cmsProvider.name", "");
      return aliasName;
    },
    similarProductsLabel() {
      return this.$i18n.t("products.productView.label.similarProducts");
    },
    commonProperties() {
      if (this.product == null) return [];
      const technicalSpecs = get(this.product, "technicalSpecs", []);
      if (!technicalSpecs || technicalSpecs.length === 0) return [];

      const currentTechnicalSpecId = get(this.product, "currentTechnicalSpec.id");
      let item = null;

      if (currentTechnicalSpecId) {
        item = technicalSpecs.find((spec) => spec.id === currentTechnicalSpecId);
      }

      if (!item) {
        const sorted = [...technicalSpecs].sort((a, b) => {
          const aYear = `${a.releaseYear || ""}`;
          const bYear = `${b.releaseYear || ""}`;
          if (aYear === "NV") return -1;
          if (bYear === "NV") return 1;
          return bYear.localeCompare(aYear, undefined, { numeric: true });
        });
        item = head(sorted);
      }

      if (item == null) return [];
      const filtered = filter(
        item.properties,
        (p) => p.classification == null || p.classification.code === "common"
      );
      return orderBy(filtered, "label.sequence", "asc");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    deliveryAddress() {
      if (this.$route.query.productType == "STORE_MTL") {
        return this.$i18n.t("products.deliveryAddress.montreal");
      } else if (this.$route.query.productType == "STORE_QC") {
        return this.$i18n.t("products.deliveryAddress.quebec");
      }
      return "";
    },
    deliveryAddressToronto() {
      if (this.$route.query.productType == "STORE_TORONTO") {
        return this.$i18n.t("products.deliveryAddress.toronto");
      }
      return "";
    },
    pickupAddress() {
      if (this.$route.query.productType == "STORE_MTL" || this.$route.query.productType == "STORE_TORONTO") {
        return this.$i18n.t("products.pickupAddress.montreal");
      } else if (this.$route.query.productType == "STORE_QC") {
        return this.$i18n.t("products.pickupAddress.quebec");
      }
      return "";
    },
    typeOfProduct() {
      var type = get(this.product, "category.code");
      var inventory = get(this.product, "inventory.code");
      if (
        type == "VIN" &&
        (inventory == "STORE_MTL" || inventory == "STORE_QC")
      ) {
        return "boutique";
      }
      return "";
    },
    isBiologique() {
      var product = get(this.product, "attributes");
      if (product) {
        const filtered = filter(
          product,
          (p) => p.code !== null && p.code === "BIO"
        );
        if (!isEmpty(filtered)) {
          return this.productLeafImg;
        }
        const filteredB = filter(
          product,
          (p) => p.code !== null && p.code === "BIODYNAMICS"
        );
        if (!isEmpty(filteredB)) {
          return this.productMoonImg;
        }
        return "";
      }
      return "";
    },
    inventory() {
      if (this.inventoryType === "IP") {
        return this.images.productInventoryIp.src;
      }
      if (this.inventoryType === "SAQ") {
        return this.images.productInventorySaq.src;
      }

      return null;
    },
    inventoryLabel() {
      var inventory = get(this.product, "inventory.code");
      const inventoryMapping = this.countryCode == 'ON' ? '' :
      // {
      //     IP: "CSMT",
      //     // SAQ: "LCBO",
      //     LCBO: "LCBO",
      //     STORE_TORONTO: "DIR",
      //     MERCH_TORONTO: 'DIR',
      //     PI: "DIR",
      //     Consignment: "PRI",
      //     null: "CSMT",
      //   } :
        {
          IP: "IP",
          SAQ: "SAQ",
          STORE_MTL: "DIR",
          Brouhh: "DIR",
          MERCH_MTL: "DIR",
          BERGEVILLE: "DIR",
          null: "",
        };
        return inventoryMapping[inventory] || "";
    },
    pastilleColor() {
      return this.getPastilleColor(this.getColorCode());
    },
    getBotiqueProduct() {
      var botiqueArray = [];
      var productInventories = get(this.productInv, "productInventories");
      var slug = get(this.productInv, "slug");
      var isMontreal = head(
        filter(
          productInventories,
          (p) => p.id != null && p.inventory && p.inventory.code === "STORE_MTL"
        )
      );
      if (!isEmpty(isMontreal)) {
        botiqueArray.push({
          code: "STORE_MTL",
          disabled: false,
          id: isMontreal.id,
          slug: slug,
          puid: isMontreal.puid,
          name: this.$i18n.t("products.boutiqueProductsView.title"),
        });
      } else {
        botiqueArray.push({
          code: "STORE_MTL",
          disabled: true,
          id: "",
          name: this.$i18n.t("products.boutiqueProductsView.title"),
        });
      }

      // var isQuebec = head(
      //   filter(
      //     productInventories,
      //     (p) => p.id != null && p.inventory && p.inventory.code === "STORE_QC"
      //   )
      // );
      // if (!isEmpty(isQuebec)) {
      //   botiqueArray.push({
      //     code: "STORE_QC",
      //     disabled: false,
      //     id: isQuebec.id,
      //     slug: slug,
      //     puid: isQuebec.puid,
      //     name: this.$i18n.t("products.boutiqueProductsQuebecView.title"),
      //   });
      // } else {
      //   botiqueArray.push({
      //     code: "STORE_QC",
      //     disabled: true,
      //     id: "",
      //     name: this.$i18n.t("products.boutiqueProductsQuebecView.title"),
      //   });
      // }

      var isToronto = head(
        filter(
          productInventories,
          (p) =>
            p.id != null && p.inventory && p.inventory.code === "STORE_TORONTO"
        )
      );
      if (!isEmpty(isToronto)) {
        botiqueArray.push({
          code: "STORE_TORONTO",
          disabled: false,
          id: isToronto.id,
          slug: slug,
          puid: isToronto.puid,
          name: this.$i18n.t("products.boutiqueProductsTorontoView.title1"),
        });
      } else {
        botiqueArray.push({
          code: "STORE_TORONTO",
          disabled: true,
          id: "",
          name: this.$i18n.t("products.boutiqueProductsTorontoView.title1"),
        });
      }
      return botiqueArray;
    },
    getAgencyProduct() {
      var productName = get(this.product, "name");
      var isAgency = filter(
        this.agencyCandidates,
        (p) =>
          p.id != null &&
          p.name === productName &&
          p.inventory &&
          p.inventory.code === "IP"
      );
      if (!isEmpty(isAgency)) {
        return isAgency;
      }
      return [];
    },
    boutiqueType() {
      if (this.$route.query.productType) {
        return this.$route.query.productType;
      }
      return "";
    },
    // Pure: the similar-products carousel is populated by loadSimilarProducts()
    // and stored in carouselProducts. Keeping this side-effect-free is what
    // stops the region-switch infinite-load (the old version fetched, mutated
    // shared state, and mutually recursed with getProductLists from inside a
    // computed).
    cloneProducts() {
      return this.carouselProducts;
    },
    titleBlogs() {
      return this.$i18n.t("home.homeView.blogsCarousel.title1");
    },
    // blogsView() {
    //   return {
    //     name: "blogs",
    //     params: {
    //       types: "TEXTE_PHOTOS",
    //     },
    //   };
    // },
    // allBlogsLink() {
    //   return this.$i18n.t("home.homeView.blogsCarousel.allBlogsLink");
    // },
    topVideos() {
      const blogs = get(this.blogs, "results");
      if (!isEmpty(blogs)) {
        const sorted = reverse(blogs);
        const val = take(
          sorted,
          this.isMobileLayout ? this.totalBlogs : blogs.length
        );
        return val;
      }

      return [];
    },
  },
  watch: {
    id() {
      this.resetState();
      if (!this.$route.query.productType) {
        this.getProduct(this.effectiveProductId);
      } else {
        this.getProduct(this.effectiveProductId);
      }
      this.previoueBtnName =
        this.$route.query.productType == "STORE_MTL" ||
        this.$route.query.productType == "STORE_QC"
          ? "boutique"
          : "agency";
      this.changeProduct = false;
      // this.getProductLists();
      this.$nextTick(() => {
        this.changeProduct = true;
      });
      this.isLoading = false;
    },
    // Vanity URL support: re-resolve when navigating directly between clean URLs
    // (slug changes, no ?id=). Guarded to no-op for legacy URLs, whose
    // navigation is already handled by the id() watcher above.
    slug() {
      if (!this.$route.query.id) {
        this.resolvedPuid = null;
        this.resetState();
        this.fetSingleProduct();
      }
    },
    productImage() {
      this.imagePopuup = true;
    },
    product(val) {
      if (this.effectiveProductId == null) {
        this.$store.commit("product/setProduct", this.productInv);
      } else {
        // NOTE: do not toggle isLoading here. This watcher runs async (nextTick)
        // on every product change, so setting isLoading=true raced against
        // getProduct's .then that sets it false — on a 2nd region switch the
        // watcher won the race and the spinner got stuck on forever even though
        // the product had loaded. isLoading is owned by getProduct/onCountryChange.
        if (val) {
          if (val.productInventories) {
            const market = localStorage.getItem("countryCode") || "QC";
            let price = this.selectProductInventory(
              val.productInventories,
              market,
              this.preferredVariantPuid
            );
            if (price) {
              val.erpProduct = price;
              val.inventory = val.erpProduct.inventory;
            }
          }
          // Don't set erpProduct = val when no productInventories;
          // fetchProductInv callback will enrich with correct market data
        }
        this.getInventoryType();
      }
    },
    products(val) {
      if (val && val.results) {
        const market = localStorage.getItem("countryCode") || "QC";
        val.results.forEach((e) => {
          if (e.productInventories) {
            let price = this.selectProductInventory(
              e.productInventories,
              market,
              e.puid
            );
            if (price) {
              e.erpProduct = price;
              e.inventory = e.erpProduct.inventory;
            }
          } else {
            e.erpProduct = e;
          }
        });
      }
    },
    releaseYear(val) {
      if (!Array.isArray(val) || val.length === 0) {
        this.activeYear = "";
        this.yearCommonProperties = null;
        this.yearProductImage = null;
        return;
      }

      const availableYears = val.map((entry) => `${entry.year}`);
      if (this.activeYear && availableYears.includes(`${this.activeYear}`)) {
        this.applyTechnicalSheetForYear(this.activeYear);
        return;
      }

      this.syncInitialTechnicalSheet(val);
    },
  },
  created() {
    this.resetState();
    this.isLoading = true;
    this.fetSingleProduct();
    this.$root.$on("chanLang", this.onLangChange);
    // this.getProductLists();
  },
  beforeDestroy() {
    // Remove the $root listeners this instance registered. Without this they
    // accumulate across every product page visit and all fire on a region/lang
    // switch (the slow-region-switch bug).
    this.$root.$off("chancountryCode", this.onCountryChange);
    this.$root.$off("chanLang", this.onLangChange);
  },
  methods: {
    ...mapActions("product", [
      "fetchProduct",
      "fetchProducts",
      "fetchProductsBoutique",
      "fetchProductBoutique",
      "fetchProductInv"
    ]),
    ...mapMutations("product", ["resetState"]),
    ...mapActions("blog", ["fetchBlogs"]),
    selectProductInventory(productInventories, market, preferredPuid) {
      if (!productInventories || productInventories.length === 0) {
        return null;
      }

      if (preferredPuid) {
        const exactMatch = productInventories.find(
          (r) => r && r.puid === preferredPuid
        );
        if (exactMatch) {
          return exactMatch;
        }
      }

      const allowedCodes = getDefaultAvailability(market).map(c => c.toUpperCase());
      return productInventories.find(
        (r) =>
          r &&
          r.inventory &&
          allowedCodes.indexOf(r.inventory.code.toUpperCase()) !== -1
      );
    },
    async onCountryChange() {
      // Own isLoading deterministically: show the spinner, refetch for the new
      // market, and only clear it once getProduct has fully resolved. Awaiting
      // getProduct (rather than the old fire-and-forget + synchronous
      // isLoading=false) is what fixes the "infinite spinner on the 2nd region
      // switch" — previously isLoading was cleared before the fetch finished and
      // the product watcher then re-raised it with nothing left to clear it.
      this.isLoading = true;
      this.resetState();
      // Market-conditional UI (the QC inventory circle, the SAQ ordering hint,
      // getInventoryType) reads this; data() only ever seeded it at creation, so
      // it kept naming the market we left.
      this.countryCode =
        localStorage.getItem("countryCode") == "QC" ? "QC" : "ON";
      this.marketSwitchPending = true;
      this.previoueBtnName =
        this.$route.query.productType == "STORE_MTL" ||
        this.$route.query.productType == "STORE_QC"
          ? "boutique"
          : "agency";
      this.changeProduct = false;
      try {
        await this.getProduct(this.effectiveProductId);
      } finally {
        this.marketSwitchPending = false;
        this.isLoading = false;
        this.$nextTick(() => {
          this.changeProduct = true;
        });
      }
    },
    onLangChange() {
      this.fetSingleProduct();
    },
    async fetSingleProduct() {
      // Vanity URL support: a clean URL (e.g. /fr/qc/products/<slug>) carries
      // only a slug and no ?id=. Resolve the slug to a puid first, then drive
      // the exact same fetch path as a legacy URL. When ?id= is present (every
      // link the app currently emits), this resolution is skipped entirely and
      // behavior is byte-identical to before.
      if (!this.$route.query.id && this.slug) {
        try {
          const resolved = await productApi.resolveSlug(this.slug, "errorHandling");
          this.resolvedPuid = get(resolved, "puid", null);
        } catch (e) {
          this.resolvedPuid = null;
        }
      }
      await this.getProduct(this.effectiveProductId);
    },
    async getProduct(id, idType) {
      this.activeYear = "";
      this.yearCommonProperties = null;
      this.yearProductImage = null;

      if (this.$route.query.productType) {
        await this.fetchProductBoutique({ id, idType })
          .then(() => {
            this.syncInitialTechnicalSheet();
            this.isLoading = false;
            this.fetchBlogs({
            filters: {
                page: 1,
                size: 52,
                // types: ["DEFAULT"],
                productId: [this.product.id],
              },
      });
          })
          .catch((error) => {
            if (errorUtils.extractErrorHttpStatusCode(error) === 404) {
              this.$router.push({
                name: "notFound",
                query: {
                  type: "products",
                },
              });
            }
          });
      } else {
        await this.fetchProduct({ id, idType })
          .then(() => {
            this.syncInitialTechnicalSheet();
            this.isLoading = false;
            this.fetchBlogs({
              filters: {
                  page: 1,
                  size: 52,
                  // types: ["DEFAULT"],
                  productId: [this.product.id],
                },
            });

          })
          .catch((error) => {
            if (errorUtils.extractErrorHttpStatusCode(error) === 404) {
              this.$router.push({
                name: "notFound",
                query: {
                  type: "products",
                },
              });
            }
          });
      }
      if (this.$route.query.pid || this.product && this.product.id) {
        await this.fetchProductInv({ id: this.$route.query.pid ? this.$route.query.pid : this.product && this.product.id, idType })
            .then(() => {
              if (this.effectiveProductId == null) {
                this.isLoading = true;
                this.$store.commit("product/setProduct", this.productInv);
              }

              // Enrich product with correct market inventory from productInv
              if (this.productInv && this.productInv.productInventories && this.product) {
                const market = localStorage.getItem("countryCode") || "QC";
                const match = this.selectProductInventory(
                  this.productInv.productInventories,
                  market,
                  this.preferredVariantPuid
                );
                // On a market switch the variant we just resolved is not the one
                // `?id=` names, and `this.product` is still the document fetched
                // by that old puid — its quantity/itemToCome (the availability
                // badge) belong to the market we left. Rewriting the id and
                // letting the id() watcher refetch gives a page that is entirely
                // the new market's, and keeps the URL shareable/refreshable.
                if (
                  this.marketSwitchPending &&
                  match &&
                  match.puid &&
                  match.puid !== this.$route.query.id
                ) {
                  this.$router
                    .replace({
                      query: { ...this.$route.query, id: match.puid },
                    })
                    .catch(() => {});
                  return;
                }
                if (match) {
                  // quantity and itemToCome on productInventories from
                  // /products/search/ are stale (raw warehouse count, no
                  // subtraction of planned reservations). The root product
                  // from /product-inventories/search/{puid} has the correct
                  // effective availability. Preserve it.
                  const rootQuantity = get(this.product, "quantity");
                  const rootItemToCome = get(this.product, "itemToCome");
                  const enriched = {
                    ...match,
                    quantity: rootQuantity || match.quantity,
                    itemToCome: rootItemToCome || match.itemToCome,
                  };
                  this.$set(this.product, "erpProduct", enriched);
                  this.$set(this.product, "inventory", match.inventory);
                  this.$set(this.product, "pricing", match.pricing);
                }
              }

              this.syncInitialTechnicalSheet();
              this.isLoading = false;
            })
            .catch((error) => {
              if (errorUtils.extractErrorHttpStatusCode(error) === 404) {
                this.$router.push({
                  name: "notFound",
                  query: {
                    type: "products",
                  },
                });
              }
            });
      }

      // Carousel + agency-variant list are loaded explicitly now that
      // cloneProducts is a pure computed. Both are safe to call on every
      // getProduct (including region switch via the chancountryCode handler):
      // loadSimilarProducts refetches market-scoped candidates, getProductLists
      // is a no-op once this.products is populated.
      this.getProductLists();
      this.loadSimilarProducts();
    },
    // Candidates for getAgencyProduct(). This used to dispatch the Vuex
    // fetchProducts/fetchProductsBoutique actions, which commit to
    // `product/products` — the SAME state the /products listing renders from.
    // So opening a product silently replaced the visitor's filtered result set
    // with an unfiltered page, and going back showed that instead: the URL and
    // every checkbox still said "Vin + Blanc" while the list was reds and rosés
    // ("les résultats ne sont plus filtrés, même si ma sélection est toujours
    // cochée"). The listing only refetches when the sidebar's models actually
    // change, so on a return with an unchanged selection nothing corrected it.
    //
    // Same request, same market scoping, same results — kept local, so this
    // page can no longer speak for the listing.
    async getProductLists() {
      if (this.agencyCandidates.length > 0) {
        return;
      }

      const isBoutique = !!this.$route.query.productType;

      if (!isBoutique && this.effectiveProductId == null) {
        this.isLoading = true;
        this.$store.commit("product/setProduct", this.productInv);
      }

      try {
        const res = isBoutique
          ? await productApi.fetchProductsBoutique({}, "errorHandling")
          : await productApi.fetchProducts({}, "errorHandling");
        this.agencyCandidates = get(res, "results") || [];
      } catch (e) {
        this.agencyCandidates = [];
      }
    },
    // Build the "similar products" carousel. Sourced server-side so it works on
    // a sparse catalogue (rosés are ~30 of ~1000 products — client-filtering a
    // default page found 0-2, hence the bug):
    //   1. CMS relatedProducts (explicit manual picks) are honored first.
    //   2. A similarity pool is fetched by the source wine's PRODUCT_COLOR
    //      attribute (the searchable proxy for its tag, e.g. Rosé -> PINK;
    //      `tags` is not a server-side filter), scoped to the current market's
    //      inventory codes so an ON product never leaks into a QC carousel.
    // Results are merged (picks first), the source product removed, and deduped
    // by sku so the same wine doesn't repeat across its SAQ/IP variants.
    async loadSimilarProducts() {
      if (!this.product) {
        this.carouselProducts = [];
        return;
      }
      const market = localStorage.getItem("countryCode") || "QC";
      const allowedCodes = getDefaultAvailability(market);

      const relatedPuids = (this.product.relatedProducts || [])
        .map((r) => (typeof r === "string" ? r : r && r.puid))
        .filter(Boolean);

      const colorCodes = (this.product.attributes || [])
        .filter((a) => a && a.type && a.type.code === "PRODUCT_COLOR" && a.code)
        .map((a) => a.code);

      try {
        const [related, similar] = await Promise.all([
          relatedPuids.length
            ? productApi.fetchProductsByPuid(relatedPuids, "errorHandling").catch(() => null)
            : Promise.resolve(null),
          colorCodes.length
            ? productApi
                .fetchProducts(
                  { attributes: colorCodes, availability: allowedCodes, size: 40 },
                  "errorHandling"
                )
                .catch(() => null)
            : Promise.resolve(null),
        ]);

        const relatedResults =
          (related && related.results) || (Array.isArray(related) ? related : []);
        const similarResults = (similar && similar.results) || [];

        const sourceId = get(this.product, "id");
        const sourceSku = get(this.product, "sku");
        const seen = new Set();
        const merged = [];
        [...relatedResults, ...similarResults].forEach((p) => {
          if (!p) return;
          if (p.id === sourceId || (sourceSku && p.sku === sourceSku)) return;
          const key = p.sku || p.puid || p.id;
          if (!key || seen.has(key)) return;
          seen.add(key);
          merged.push(p);
        });

        enrichProductsForMarket(merged, market);
        this.carouselProducts = sortByHierarchyWithAlternation(merged, market);
      } catch (e) {
        this.carouselProducts = [];
      }
    },
    getInventoryType() {
      return get(this.product, "inventory.code");
    },
    getColorCode() {
      const vm = this;
      const attributes = get(vm.product, "attributes");

      if (attributes != null) {
        const color = head(
          filter(
            attributes,
            (attribute) =>
              get(attribute, "type.code") === vm.constants.PRODUCT_COLOR
          )
        );

        if (color != null) {
          return color.code;
        }
      }

      return null;
    },
    getPastilleColor(code) {
      switch (code) {
        case this.constants.WHITE:
          return cssVariables.pastilleWhite;
        case this.constants.PALE_ORANGE:
          return cssVariables.pastilleOrangeLight;
        case this.constants.ORANGE:
          return cssVariables.pastilleOrange;
        case this.constants.RAMATO:
          return cssVariables.pastilleRamato;
        case this.constants.PINK:
          return cssVariables.pastilleRose;
        case this.constants.PALE_RED:
          return cssVariables.pastilleRedLight;
        case this.constants.RED:
          return cssVariables.pastilleRed;
        case this.constants.COLORLESS:
          return cssVariables.pastilleClear;
        case this.constants.AMBER:
          return cssVariables.pastilleAmber;
        case this.constants.BLACK:
          return cssVariables.pastilleBlack;
        default:
          return cssVariables.pastilleClear;
      }
    },
    popupImageClose() {
      this.productImagePopup = false;
    },
    setBackBtnName() {
      if (
        this.$route.params.backBtnName &&
        this.$route.params.backBtnName != ""
      ) {
        return this.$route.params.backBtnName;
      }
      if (this.$route.query.productType == "STORE_MTL") {
        return "montrealShop";
      }
      if (this.$route.query.productType == "STORE_QC") {
        return "quebecShop";
      }
      if (this.$route.query.productType == "STORE_TORONTO") {
        return "torontoShop";
      }
      return "agency";
    },
    setBackBtnLink() {
      if (this.$route.query.productType == "STORE_MTL") {
        return {
          name: "products",
          query: {
            page: 1,
            inventory: "STORE_MTL",
            req: true,
          },
        };
      }
      if (this.$route.query.productType == "STORE_QC") {
        return {
          name: "products",
          query: {
            page: 1,
            inventory: "STORE_QC",
            req: true,
          },
        };
      }
      if (this.$route.query.productType == "STORE_TORONTO") {
        return {
          name: "products",
          query: {
            page: 1,
            inventory: "STORE_TORONTO",
            req: true,
          },
        };
      }
      return {
        name: "products",
        query: {
          page: 1,
          req: true,
        },
      };
    },
    resolveInitialTechnicalSheetYear(years = this.releaseYear) {
      if (!Array.isArray(years) || years.length === 0) {
        return "";
      }

      // Priority 1: currentTechnicalSpec year (the one the backend says is current)
      if (
        this.currentTechnicalSpecYear &&
        years.some((entry) => `${entry.year}` === this.currentTechnicalSpecYear)
      ) {
        return this.currentTechnicalSpecYear;
      }

      const currentVintage = get(this.product, "currentVintage");
      const inStockQuantity = Number(
        get(this.product, "quantity.inStock", get(this.product, "erpProduct.quantity.inStock", 0))
      );

      // Priority 2: current vintage if in stock
      if (inStockQuantity > 0) {
        if (currentVintage && years.some((entry) => `${entry.year}` === `${currentVintage}`)) {
          return `${currentVintage}`;
        }
      }

      // Priority 3: first year with inventory
      const availableYear = years.find((entry) => Number(entry.onHand) > 0);
      if (availableYear && availableYear.year) {
        return `${availableYear.year}`;
      }

      // Priority 4: incoming vintage
      const incomingVintage =
        get(this.product, "itemToCome.vintage") ||
        get(this.product, "erpProduct.itemToCome.vintage");
      if (incomingVintage && years.some((entry) => `${entry.year}` === `${incomingVintage}`)) {
        return `${incomingVintage}`;
      }

      // Priority 5: currentVintage regardless of stock
      if (currentVintage && years.some((entry) => `${entry.year}` === `${currentVintage}`)) {
        return `${currentVintage}`;
      }

      // Priority 6: first year in list (most recent, since years are sorted desc)
      return `${years[0].year}`;
    },
    syncInitialTechnicalSheet(years = this.releaseYear) {
      const initialYear = this.resolveInitialTechnicalSheetYear(years);

      if (!initialYear) {
        this.activeYear = "";
        this.yearCommonProperties = null;
        this.yearProductImage = null;
        return;
      }

      this.activeYear = initialYear;
      this.applyTechnicalSheetForYear(initialYear);
    },
    applyTechnicalSheetForYear(year) {
      const selectedYear = year && year.name != null ? `${year.name}` : `${year || ""}`;

      if (!selectedYear) {
        this.yearCommonProperties = null;
        this.yearProductImage = null;
        return [];
      }

      if (this.currentTechnicalSpecYear && this.currentTechnicalSpecYear === selectedYear) {
        this.yearProductImage = null;
        if (this.product == null) return [];
        const item = get(this.product, "technicalSheet");
        if (item == null) return [];
        this.yearProductImage = get(item, "image.thumbnailLink", null);
        this.yearCommonProperties = orderBy(item.properties, "sequence", "asc");
        return this.yearCommonProperties;
      }

      this.yearProductImage = null;
      if (this.product == null) return [];
      const item = get(this.product, "technicalSpecs");
      if (item == null) return [];
      const filtered = filter(item, (productTechnicalSpec) => `${productTechnicalSpec.releaseYear}` === selectedYear);
      if (filtered == null || filtered.length === 0) {
        this.yearCommonProperties = null;
        return {};
      }
      this.yearProductImage = get(filtered[0], "image.thumbnailLink", null);
      const properties = head(filtered);
      this.yearCommonProperties = orderBy(properties.properties, "sequence", "asc");
      return this.yearCommonProperties;
    },
    getYearCommonProperties(year) {
      return this.applyTechnicalSheetForYear(year);
    },
  },
  // updated() {
  //   this.inventoryType = get(this.product, "inventory.code");
  // },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
$logo-dimension: 16px;

.product-container {
  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $container-max-width-md;
    margin-left: auto;
    margin-right: auto;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $container-max-width-lg;
    margin-left: auto;
    margin-right: auto;
  }
}
.rectangle {
  padding-top: 20px;
  background-color: rgba(237, 240, 237, 0.33);
  position: relative;
}
.product-name {
  letter-spacing: 0.6px;
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    font-size: 48px;
  }
  @media screen and (min-width: $media-lg) {
    font-size: 48px;
    letter-spacing: 0px;
    line-height: 1;
  }
}
.light-grey {
  color: $color-on-background-area1;
}

.disponible-label {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  color: #272421;
  line-height: normal;
  letter-spacing: 0.4px;
}
.couleur-disponible {
  width: 10px;
  height: 10px;
  background-color: #70b603;
}
.couleur-non-disponible {
  width: 10px;
  height: 10px;
  background-color: $color-primary;
}
.releaseYear {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  color: #272421;
  font-size: 10px;
  font-weight: 300;
  text-align: left;
  line-height: normal;
  letter-spacing: 1.5px;
}
.prop-label {
  font-family: 'Futura-Medium', 'Futura Medium', 'Futura Std', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #272421;
  text-align: left;
  line-height: 28px;
  letter-spacing: 0.25px;
}
.prop-value {
  font-family: 'FuturaStd-Book', 'Futura Std Book', 'Futura Std', sans-serif;
  color: #272421;
  font-size: 14px;
  font-weight: 300;
  text-align: left;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.product-image {
  // Product images are standardized square (800x800). Lock the box to a 1:1
  // ratio of its (language-independent) column width so its height can never
  // track the description/text column or image-load timing — the image must
  // not change height when switching languages. Matches the current rendered
  // size (square = column width); contain letterboxes any non-square image.
  width: 100%;
  aspect-ratio: 1 / 1;
  height: auto;
  max-height: 700px;
  cursor: -webkit-zoom-in;
}
.product-availability-label {
  margin-top: -2px;
  font-family: 'Futura Std', 'Futura Std Book', 'Futura Std', 'sans-serif' !important;

}
.provider-logo {
  filter: invert(35%) sepia(86%) saturate(2207%) hue-rotate(85deg)
    brightness(85%) contrast(40%);
}
.provider-logo__dimension {
  height: $logo-dimension;
  width: $logo-dimension;
}
.delivery {
  span {
    font-size: 12px;
  }
  i {
    font-size: 40px;
  }
  p {
    font-size: 14px;
  }
  .delivery-icon {
    width: 50px;
  }
}
.biologique-logo {
  width: 16px;
}
.provider {
  font-size: 14px;
  margin-top: 5px;
  font-weight: 300;
}
.inventory__label {
  padding-top: 1px;
  order: 2;
  bottom: 20px;
  right: 21px;
  height: 16px;
  width: fit-content;
  line-height: normal;
  padding: 0px 5px;
}
// .inventory__saq {
//   position: absolute;
//   bottom: 20px;
//   right: 21px;
//   height: 16px;
//   width: 41px;
// }
.inventory {
  border-radius: 2px;
  border: 1px solid rgba(39, 36, 33, 0.33);
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 700;
  color: rgba(39, 36, 33, 0.33);
  text-align: center;
  line-height: normal;
  letter-spacing: 0.4px;
  font-size: 12px;
  color: #fff;
  background-color: #b4b3b2;
  border: 0;
  padding-top: 2px;
}
.circle {
  width: 12px;
  height: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  background: red;
  margin-left: 5px;
}
.circle--position {
  bottom: 22px;
  right: 60px;
}
.circle--position-display {
  bottom: 22px;
  right: 45px;
}
#product-carousel {
  margin-bottom: 20px;
}
.release-year {
  font-weight: 500;
  font-size: 12px;

  span {
    margin-left: 3px;
  }
  .current-year {
    font-weight: 700;
  }
  .year-first-element {
    margin-left: -3px;
  }
  
}
</style>
